import { render, staticRenderFns } from "./trialList.vue?vue&type=template&id=888a2218&scoped=true&"
import script from "./trialList.vue?vue&type=script&lang=js&"
export * from "./trialList.vue?vue&type=script&lang=js&"
import style0 from "./trialList.vue?vue&type=style&index=0&id=888a2218&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888a2218",
  null
  
)

export default component.exports